import React from "react";
import { Box, Text, useBreakpoint } from "@chakra-ui/react";
import { keyframes } from "@emotion/react";
import { TbDeviceImacCode } from "react-icons/tb";

const SmllerSeperator = () => {
  const rotateIn = keyframes`0%{
        opacity:0;
        transform:rotate3d(0,0,1,-200deg);
    }
    100%{
        opacity:1;
        transform:rotate3d(0,0,0);
    }
    `;
  return (
    <Box
      h="full"
      w="2%"
      pos="relative"
      display={{ base: "none", smm: "block" }}
    >
      <Box
        pos="absolute"
        top="2%"
        left="-50%"
        color={"rgb(94,234,212)"}
        bg="#000"
        animation={`${rotateIn} 1s linear`}
        fontSize="1.5rem"
      >
        <TbDeviceImacCode />
      </Box>
      <Box h={{ base: "400px", sm: "350px" }} w="1px" bg="#e7eaec" />
    </Box>
  );
};

export default SmllerSeperator;
